import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {InjectedRouter} from 'react-router';
import {Link} from 'react-router';
import Radium, { StyleRoot } from 'radium';
import {CampusFeedback } from '../FlatPages/CampusFeedback';


const splashHdr: React.CSSProperties = {
    fontFamily:'BarlowMedium',
    textAlign:'center',
    color:'#555853',
    opacity:.9,
    letterSpacing:'1px',
    fontSize:'26px',
    marginTop:'25px'
}

const splashBtn: React.CSSProperties = {
    width:'370px',
    backgroundColor:'#AAB8C7',
    height:'106px',
    textAlign:'center',
    fontFamily:'BarlowLight',
    color:'white',
    borderRadius:'15px',
    cursor:'pointer',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    marginRight:'20px',
    boxShadow:'10px 10px 5px #DCDCDA',
    ':hover': {
        backgroundColor:'white',
        color:'#AAB8C7'
    }
}
const restaurant = Object.assign({},splashBtn,{marginLeft:'20px',marginRight:'unset'})

const corpBtnStyle1 : React.CSSProperties = {
    fontFamily:'BarlowLight',
    width:'370px',
    height:'106px',
    textAlign:'center',
    backgroundColor:'#AAB8C7',
    color:'white',
    borderRadius:'15px',
    cursor:'pointer',
    letterSpacing:'1px',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    marginLeft:'20px',
    boxShadow:'10px 10px 5px #DCDCDA',
    ':hover': {
        backgroundColor:'white',
        color:'#AAB8C7'
    }
}

const splashFooter: React.CSSProperties = {
    textAlign:'center',
    color:'#464A46',
    fontFamily:'BarlowLight',
    fontSize:'18px',
    letterSpacing:'1px',
    marginTop:'75px',
}
const btnCont: React.CSSProperties = {
    display:'flex',
    flexDirection:'row',
    marginTop:'40px',
    fontFamily:'BarlowMedium'
}
const greekLine: React.CSSProperties = {
    fontSize:'20px',
}

const gcLogo: React.CSSProperties = {
    width:'12%',
    marginTop:'25px'
}
const splashDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'column',
    alignItems:'center',
    height:'100%'
}
const select: React.CSSProperties = {
    fontFamily:'Lulo',
    fontSize:'28px',
    marginTop:'55px',
    textAlign:'center'
}
class _SplashPage extends React.Component <Tgcc.BaseProps, any > {

    openCampus = () =>{browserHistory.push(Tgcc.Routes.Campus)};

    openHome = () =>{browserHistory.push(Tgcc.Routes.Home)};
    openIndigo = ()=>{browserHistory.push(Tgcc.Routes.Indigo)};
    openK12 = () =>{browserHistory.push(Tgcc.Routes.K12Landing)};

    componentDidMount(){
        var el = document.getElementById("splashPage");
        el.scrollIntoView(false);
    }

    render() {
        return (
            <StyleRoot>
                <div style={splashDiv} className="splashDiv">
                    <CampusFeedback state={this.props.state} />

                    <div id="splashPage"></div>
                    <img src={Tgcc.ResolveUrl('~/images/2022Logo.png')} style={gcLogo} className='splashLogo'/>
                    <div style={splashHdr}>Custom Apparel, Made Simple.</div>
                    <div style={select}>SELECT YOUR CUSTOMER TYPE BELOW:</div>
                    <div style={btnCont} className='splashBtnDiv'>               
                        <div style={splashBtn} onClick={this.openCampus} className='campusBtn'>
                            <div style={greekLine}>COLLEGIATE &amp; GREEK</div>
                        </div>
                            <div style={corpBtnStyle1} onClick={this.openHome} key='1' className='corpBtn'>
                                <div style={greekLine}>CORPORATE, CAMPS,<br/>CHURCHES, &amp; K12</div>
                            </div>
                    </div>
                    <div style={btnCont} className='splashBtnDiv'>
                            <div style={splashBtn} onClick={this.openIndigo} key='2' className='corpBtn1'>
                                <div style={greekLine}>RESORTS & DESTINATIONS</div>
                            </div>
                   </div>
                    <div style={splashFooter} className='splashFooter'>
                        <div>Not sure where to go&#63;</div>
                        <div>Contact us at 800-472-3269</div>
                    </div>
                </div>
            </StyleRoot>

        );
    }
}

export var SplashPage = Radium(_SplashPage);



